// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MM_context = require("../mm-utils/MM_context.res.js");
var MM_wrk_client = require("./MM_wrk_client.res.js");

var procName = "MM_wrk_FindParens";

function reqToStr(req) {
  return "FindParens";
}

function respToStr(resp) {
  if (resp.TAG === "FindParensProgress") {
    return "FindParensProgress(pct=" + String(resp.pct) + ")";
  } else {
    return "FindParensDone(parens=\"" + resp.parens + "\")";
  }
}

function beginFindParens(ctx, onProgress, onDone) {
  MM_wrk_client.beginWorkerInteraction(procName, {
        TAG: "FindParens",
        ctx: ctx
      }, (function (resp, param, endWorkerInteraction) {
          if (resp.TAG === "FindParensProgress") {
            return onProgress(resp.pct);
          }
          endWorkerInteraction();
          onDone(resp.parens);
        }), undefined, undefined, undefined);
}

function processOnWorkerSide(req, sendToClient) {
  var ctx = req.ctx;
  sendToClient({
        TAG: "FindParensDone",
        parens: (function (__x) {
              return MM_context.ctxIntsToStrExn(ctx, __x);
            })(MM_context.findParentheses(ctx, (function (pct) {
                    sendToClient({
                          TAG: "FindParensProgress",
                          pct: pct
                        });
                  })))
      });
}

exports.procName = procName;
exports.beginFindParens = beginFindParens;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* MM_context Not a pure module */
